import { IRecommendations } from './types';
import { mapRecommendations } from './mapRecommendations';
import MerchRecommendationsCarousel from '@components/MerchRecommendationsCarousel';
import { useFeatureIsOn } from '@monofront/business/contexts';
import withSlice from '@screens/SlicesContainer/withSlice';
import { useProductPageContext } from '@context/ProductPageContext';
import { useMemo } from 'react';

const Recommendations: React.FC<IRecommendations> = ({ contents }) => {
  const { sku, isProductPage } = useProductPageContext();
  const isVariant = useFeatureIsOn(contents.abTestId);
  const widgetId =
    (isVariant ? contents.widgetIdB : contents.widgetIdA) || contents.widgetIdA;
  const trackingId = `${contents.trackingId}${
    isVariant && contents?.widgetIdB ? '-variantb' : ''
  }`;

  const widgetContext = useMemo(
    () => ({
      widgetName: trackingId,
      widgetPosition: `${contents.position}`,
    }),
    [trackingId, contents.position],
  );

  if (isProductPage && !sku) return null;

  return (
    <section>
      <MerchRecommendationsCarousel
        title={contents.title}
        isOnCardClickDisabled={contents.isOnCardClickDisabled || false}
        isProductDrawerEnabled={contents.isProductDrawerEnabled || false}
        widgetId={widgetId}
        widgetContext={widgetContext}
        sku={sku}
        trackingId={trackingId}
      />
    </section>
  );
};

export default withSlice(Recommendations, mapRecommendations);
